import { QuestionConfigurator } from './question';
import { EmailView } from '../view';
import { EmailValidator } from '../validator';

export class EmailConfigurator extends QuestionConfigurator {
  get view() {
    return EmailView;
  }

  initValidator() {
    this.validator = new EmailValidator();
  }

  getDefaultData(): Object {
    return {
      selectedOption: undefined,
      yes: this.serverContext.CurrentUser.Email,
      ...this.data,
    };
  }

  getDefaultDirtyState(bool): Object {
    const state = {
      isDirty: bool,
    };
    const { options } = this.configuration;
    options.forEach((option) => {
      const { key } = option;
      state[key] = bool;
    });
    return state;
  }

  getFeedbackData(answers: any): any {
    const data = answers[this.key];
    if (data.selectedOption === 'yes') { return data.yes; }
    return null;
  }
}
